import { IRefIds } from 'constants/refs';
import { get } from 'services/request';
import { IGridData } from '../types/models';
import { BaseModel } from './BaseModel';

type IBatchRef = {
  ref: IRefIds;
  name: string;
};

export default class InflectTargetBatchModel extends BaseModel<IGridData, IBatchRef[]> {
  async loadItemData(itemId = 0) {
    return await get<IBatchRef[]>(`target-inflect-batch-resources`);
  }
}
